import React, {Component} from 'react';
import Slider from "react-slick";


import  galery1 from './../../images/banner/banner.jpeg';
import  galery2 from './../../images/banner/banner2.jpeg';
import  galery3 from './../../images/banner/banner1.png';
import  galery4 from './../../images/banner/banner.jpeg';


function SampleNextArrow(props) {
  const { onClick } = props;
  return (
  	<div className="owl-nav">
		<div className="owl-next la la-angle-right"  onClick={onClick}/>
	</div>	
  );
}

function SamplePrevArrow(props) {
  const { onClick } = props;
  return (
	<div className="owl-nav">
		<div className=" owl-prev la la-angle-left" onClick={onClick} style={{zIndex:1 }}/>
	</div>
  );
}

class ExhibitionSlider1 extends Component{
	
	render(){
		var settings = {		
			arrows: true,
			dots: true,
            slidesToShow: 1,			
            infinite: true,
			autoplay: true,
			nextArrow: <SampleNextArrow />,
			prevArrow: <SamplePrevArrow />,
			responsive: [
				{
				  breakpoint: 1200,
				  settings: {
					slidesToShow: 1,
					
				  }
				},
				{
				  breakpoint: 991,
				  settings: {
					slidesToShow: 1,
					
				  }
				},
				{
				  breakpoint: 576,
				  settings: {
					slidesToShow: 1,
					
				  }
				}
			]
        };
		return(
			<>
				<style>{`
					.exhibition-carousel .item img {
						width: 100%;
						height: 400px;
						object-fit: cover;
						display: block;
					}
					@media (max-width: 768px) {
						.exhibition-carousel .item img {
							height: 400px;
						}
					}
					@media (max-width: 576px) {
						.exhibition-carousel .item img {
							height: 300px;
						}
					}
				`}</style>
				<Slider className="exhibition-carousel owl-carousel owl-none m-b30 " {...settings}>
					<div className="item"><img className="w-100" src={galery1} alt="" /></div>
					<div className="item"><img className="w-100" src={galery2} alt="" /></div>
					<div className="item"><img className="w-100" src={galery3} alt="" /></div>
					<div className="item"><img className="w-100" src={galery4} alt="" /></div>
				</Slider>
			</>
		)
		
	}
	
}

export default ExhibitionSlider1;